/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  AdHeader,
  RadiosContainer,
} from '../styles';
import {
  InfoBanner, Radio,
} from '../../../components';
import { Admin } from '../../../utils/api';
import { AddIndividualPlayer, BulkUpload } from './';
import OnboardingBulkUpload from './onboardingBulkUpload/onboardingBulkUpload';

export default ({ handleView, teamMemo }) => {
  const [radio, useRadio] = useState<any>({ one: true, two: false, three: false });
  const [membershipsYearly, setMembershipsYearly] = useState<any>();
  const [membershipsYearlyCount, setMembershipsYearlyCount] = useState<any>();
  const [membershipsYearlyTotal, setMembershipsYearlyTotal] = useState<number>(0);
  const ADMIN = new Admin();

  const newMembershipCount = [
    { number: membershipsYearlyCount || 0, text: 'Premium Yearly' },
  ];

  useEffect(() => {
    FetchMembershipYearly();
  }, []);

  useEffect(() => {
    if (membershipsYearly) {
      setMembershipsYearly([...membershipsYearly].map(prev => ({ ...prev, selected: false })))
    }
  }, [radio])

  useEffect(() => {
    setMembershipsYearlyCount(newMembershipsCount(membershipsYearly));
    if (membershipsYearly) {
      setMembershipsYearlyTotal([...membershipsYearly.filter(item => !item.selected)].length);
    }
  }, [membershipsYearly]);

  function HandleRadiosButtons(e: any): void {
    if (e.target.id === 'bulk') {
      useRadio({ one: false, two: true, three: false });
    } else if (e.target.id === 'add') {
      useRadio({ one: true, two: false, three: false });
    } else {
      useRadio({ one: false, two: false, three: true });
    }
  }

  async function FetchMembershipYearly(): Promise<void> {
    const resMemberShip = await ADMIN.GetMembershipsAvailable('yearly');
    setMembershipsYearly(resMemberShip.data.data.map(membership =>
      ({ ...membership, selected: false })));
  }

  function newMembershipsCount(block) {
    if (block){
      return block.filter(item => !item.selected && item.unused).length
    }

    return 0
  }

  function handleViewForm() {
    if(radio.one)
      return <AddIndividualPlayer
        membershipsYearly={membershipsYearly}
        membershipsYearlyCount={membershipsYearlyCount}
        membershipsYearlyTotal={membershipsYearlyTotal}
        changeMembershipsYearly={setMembershipsYearly}
        handleView={handleView}
      />
    if(radio.two)
      return <BulkUpload
        membershipsYearly={membershipsYearly}
        membershipsYearlyCount={membershipsYearlyCount}
        membershipsYearlyTotal={membershipsYearlyTotal}
        changeMembershipsYearly={setMembershipsYearly}
        handleView={handleView}
        teamMemo={teamMemo}
      />
    if(radio.three)
      return <OnboardingBulkUpload
        membershipsYearly={membershipsYearly}
        membershipsYearlyCount={membershipsYearlyCount}
        membershipsYearlyTotal={membershipsYearlyTotal}
        changeMembershipsYearly={setMembershipsYearly}
        handleView={handleView}
        teamMemo={teamMemo}
      />
  }

  return (
    <div style={{overflow: 'scroll'}}>
      <AdHeader>
        <RadiosContainer onChange={HandleRadiosButtons} data-cy="addPlayers-options">
          <Radio title="Add Individual Players" name="tableInfo" id="add" checked={radio.one} dynamicActive={radio.one} />
          <Radio title="Bulk upload" name="tableInfo" id="bulk" checked={radio.two} dynamicActive={radio.two} />
          <Radio title="Onboarding bulk upload" name="tableInfo" id="onboardingBulk" checked={radio.three} dynamicActive={radio.three} />
        </RadiosContainer>
        <InfoBanner data={newMembershipCount} title={'New'} />
      </AdHeader>

      {handleViewForm()}
    </div>
  );
};
